import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { holdingUsersApi, type UpdateHoldingUserPayload } from '@/api/holding-users';

const KEY = ['holding', 'users'] as const;
const FILIALES_KEY = ['holding', 'filiales'] as const;

export const useHoldingFiliales = () =>
  useQuery({
    queryKey:  FILIALES_KEY,
    queryFn:   () => holdingUsersApi.listFiliales(),
    staleTime: 60_000,
  });

export const useHoldingUsers = (filiale?: string) =>
  useQuery({
    queryKey:  [...KEY, filiale ?? 'all'],
    queryFn:   () => holdingUsersApi.list(filiale),
    staleTime: 30_000,
  });

export const useUpdateHoldingUser = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ userId, filiale, payload }: { userId: string; filiale: string; payload: UpdateHoldingUserPayload }) =>
      holdingUsersApi.update(userId, filiale, payload),
    onSuccess:  () => qc.invalidateQueries({ queryKey: KEY }),
  });
};

export const useDeleteHoldingUser = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ userId, filiale }: { userId: string; filiale: string }) =>
      holdingUsersApi.remove(userId, filiale),
    onSuccess:  () => qc.invalidateQueries({ queryKey: KEY }),
  });
};

export const useResetHoldingUserPassword = () =>
  useMutation({
    mutationFn: ({ userId, filiale }: { userId: string; filiale: string }) =>
      holdingUsersApi.resetPassword(userId, filiale),
  });
